import { requestBuilder } from '../../http/RequestBuilder';
import type { IGoalTask } from '../types/Goal';

interface UpdateGoalTaskBody {
    membershipId: string;
    status: string; // TODO enum
}

interface UpdateGoalTaskURLParams {
    goalTaskId: string;
}

const useUpdateGoalTask = requestBuilder.mutation<
    IGoalTask,
    UpdateGoalTaskBody,
    UpdateGoalTaskURLParams
>({
    endpoint: ({ goalTaskId }) => `/api/guidance/goals/tasks/${goalTaskId}`,
    method: 'PATCH',
});

export default useUpdateGoalTask;
